import axios from '../axiosConfig'; // Assuming this is your configured Axios instance
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;

const getTimeOffList = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.get('/office/timeoff?start_date='+data.start_date+'&end_date='+data.end_date,{
        headers: headers
      });
      console.log(response);

      return response;
    } catch (error) {
      return error;
    }
  };

  const addTimeOff = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.post('/office/timeoff',data, {
        headers: headers
      });
      console.log(response);
      return response;  
    }  
    catch (error) {
      return error; 
    }
  }

  const updateTimeOff = async (id, data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'}; 
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`; 
    }
    try {
      const response = await axios.put(`/timeoff/update/${id}`, data, {
        headers: headers
      });
      console.log(response);
      return response; 
    }
    catch (error) {
      return error; 
    }
  }
  const deleteTimeOff = async (id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    try {
      const response = await axios.delete(`/timeoff/delete/${id}`, {
        headers: headers
      });
      console.log(response);
      return response; 
    }   
    catch (error) {
      return error;
    }
  }

  const addDocumentFile = async (data) => {
    var headers = {'Content-Type': 'multipart/form-data', 'Accept': 'application/json'}; 
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`; 
    }
    try {
      const response = await axios.post(`/timeoff/document`, data, {
        headers: headers
      });
      console.log(response);
      return response;  
    }
    catch (error) {
      return error; 
    }
  }
export {getTimeOffList, addTimeOff, updateTimeOff, deleteTimeOff,addDocumentFile}